module.exports = __webpack_public_path__ + "img/logo-branco-refuturiza.8ad3dc72.svg";